/** LinkedIn profile strings (extracted from en.ts to keep it under the size ratchet). */
export const enLiProfile = {
	title: "LinkedIn Profile",
	search: "Search for Profile",
	engagement: "Engagement",
	post: "Post",
	name: "Name",
	subtitle: "Your LinkedIn Profile",
	url: "URL of Linkedin Profile",
	urlTitle: "URLs",
	type: "Type",
	observeIndividual: "Observe Individual",
	individualExample: `"Hey Person, I saw you posted..."`,
	reactionsWithPerson: "Reactions with Person",
	reactedWithExample: `"Hey Xyz, I saw you liked Person's post..."`,
	titlePerson: "Title",
	headline: "Headline",
	linkedinUrl: "LinkedIn URL",
	content: "Content",
	contentResponse: "Content Response",
	country: "Personal Country",
	city: "Personal City",
	companyName: "Company Name",
	companyLinkedinUrl: "Company LinkedIn URL",
	companyCountry: "Company Country",
	companyCity: "Company City",
	create: {
		button: "Create new Profile Scraper",
		title: "Create new Profile Scraper",
	},
	update: {
		title: "Update Profile Scraper",
	},
	tabs: {
		results: "Results",
		costs: "Costs",
	},
	linkedinProfilePosts: "LinkedIn Profile Posts",
	linkedinProfileComments: "LinkedIn Profile Comments",
	linkedinProfileLikesToPost: "LinkedIn Profile Likes to Post",
	linkedinProfileLikesToComment: "LinkedIn Profile Likes to Comment",
	linkedinProfileCommentsToPost: "LinkedIn Profile Comments to Post",
	timeFrame: "Time frame in days. (Post is max 30 days old)",
	timeFramePlaceholder: "30",
	namePlaceholder: "Enter a source name",
	urlPlaceholder: "Enter a LinkedIn profile URL",
	status: "Status",
	delete: {
		title: "Delete profile source",
	},
};
